import Page from './index';
import { authRoles } from 'app/auth';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				}
			}
		}
	},
	// auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/company/:id/end-users',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/end-user/detail/:id',
			exact: true,
			component: Page.Details
		},
	]
};